module.exports = __webpack_public_path__ + "assets/list-layout.dd6f42b3.svg";